import { useEffect, useRef } from 'react'

import useAcquiredModelOpener from 'Pods/LazyLoaded/ThreeDModelPicker/Hooks/useAcquiredModelOpener'
import { useLocation } from 'Pods/Shared/ContextBasedRouter'

import { parseRunSlugFromPathname } from './parseRunSlugFromPathname'

// Opens a model the user already owns straight in the viewer, for the "Edit with AI" action
// in My Purchases (`/ai-3d-model-generator/3d-models/<item-slug>`). That path is otherwise a
// generated run, and the two slug namespaces live in different databases with no shared
// uniqueness - so the server decides which kind the slug is and says so in `acquiredItemSlug`.
// Trusting only that verdict keeps a run slug from ever being opened as a purchase.
// Entitlement is not part of the verdict (the prop must stay identical for every viewer);
// it is enforced when the file is handed out, and an unentitled visitor gets the error toast.
// Keyed on the slug rather than a one-shot flag - the open is asynchronous, so a re-render
// must not start a second prepare request for the model already opening.
const useDeepLinkAcquiredModel = (acquiredItemSlug = null) => {
  const location = useLocation()
  const { openModel } = useAcquiredModelOpener()
  const openedSlugRef = useRef(null)

  const pathname = location?.pathname ?? ''

  useEffect(() => {
    const slug = parseRunSlugFromPathname(pathname)

    if (slug == null || slug !== acquiredItemSlug) {
      openedSlugRef.current = null
      return
    }

    if (openedSlugRef.current === slug) return

    openedSlugRef.current = slug

    openModel(slug, { targetPathname: pathname })
  }, [pathname, acquiredItemSlug, openModel])
}

export default useDeepLinkAcquiredModel
